import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const NextArrow = ({ onClick }) => (
  <div className="slick-arrow slick-next customArrow" onClick={onClick}>
    ❯
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow slick-prev customArrow" onClick={onClick}>
    ❮
  </div>
);

const MainSlider = () => {
  var settings = {
 dots: true,
  infinite: true,
  fade: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  };
  return (
    <>
      <div className="slider_blk">
        <Slider {...settings}>

          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld22.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld24.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld9.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld7.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld16.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld6.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld19.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld11.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>

          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld23.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld20.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld8.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld5.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld2.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld4.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld1.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld3.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld10.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld12.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld13.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld14.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld15.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld17.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld18.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>

          {/* 
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld22.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld24.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld9.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld7.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld16.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld6.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld19.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sld11.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div> */}

        </Slider>
      </div>
    </>
  )
}
export default MainSlider